import React from 'react';
import { useTranslation } from 'react-i18next';

import ComponentCircleLoader from '../../../components/Loaders/ComponentCircleLoader';
import NoDataComponent from '../../../components/NoDataComponent/NoDataComponent';
import TaskDetails from '../TaskDetails/TaskDetails';

const ApprovalTasksList = props => {
  const { t } = useTranslation();

  const {
    handleClearSearch,
    handleSearchByName,
    onSearchTermChange,
    searchTerm,
    isLoading,
    tasksList,
    popupOpen,
    setPopupOpen,
    setEvidenceImage,
    updateTaskStatusRequest,
    selectedTab,
    editSubTask,
    updateTaskApproval,
    getOrganizationMembersList,
    orgMembersList,
    memberShortListIsLoading,
    reassignAssigneeLoading,
    reassignAssignee,
  } = props;

  return (
    <>
      {isLoading ? (
        <ComponentCircleLoader />
      ) : tasksList && tasksList.length > 0 ? (
        tasksList.map(task => (
          <TaskDetails
            key={task.id}
            taskDetails={task}
            approvalMode
            selectedTab={selectedTab}
            editSubTask={editSubTask}
            updateTaskApproval={updateTaskApproval}
            getOrganizationMembersList={getOrganizationMembersList}
            orgMembersList={orgMembersList}
            memberShortListIsLoading={memberShortListIsLoading}
            reassignAssigneeLoading={reassignAssigneeLoading}
            reassignAssignee={reassignAssignee}
          />
        ))
      ) : (
        <NoDataComponent
          title={t('no_tickets_found')}
          padding="5vh 0"
          imageHeight="140px"
        />
      )}
    </>
  );
};

export default ApprovalTasksList;
